import { get } from 'lodash';
import * as React from 'react';

const InvoiceData = ({ data }) => {
    const companyName = get(data, 'attributes.company_name','');
    const nsn = get(data, 'attributes.nsn','');
    const address = get(data, 'attributes.address','');
    const city = get(data, 'attributes.address','');
    const mol = get(data, 'attributes.mol','');
    const vatRegistration = get(data, 'attributes.vat_registration','');

    return (
        <div>
            <h5>Данни за фактура:</h5>
            <p>Име на фирма: <strong>{companyName}</strong></p>
            <p>ЕИК: <strong>{nsn}</strong></p>
            <p>Адрес: <strong>{address}</strong></p>
            <p>Град: <strong>{city}</strong></p>
            <p>МОЛ: <strong>{mol}</strong></p>
            <p>ДДС регистрация: <strong>{vatRegistration ? 'Да' : 'Не'}</strong></p>
        </div>
    );
};

export default InvoiceData;



// WEBPACK FOOTER //
// ./src/components/Orders/OrdersList/OrderDetails/InvoiceData.js